import { apiClient, APIResponse, extractApiError, buildQuery } from './api';

export const liabilitiesAPI = {
  async list(params) {
    try {
      const { data } = await apiClient.get(`/liabilities/${buildQuery(params)}`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar as dívidas.'),
      );
    }
  },

  async retrieve(id) {
    try {
      const { data } = await apiClient.get(`/liabilities/${id}/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar a dívida.'),
      );
    }
  },

  async create(payload) {
    try {
      const { data } = await apiClient.post('/liabilities/', payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível criar a dívida.'),
      );
    }
  },

  async update(id, payload) {
    try {
      const { data } = await apiClient.patch(`/liabilities/${id}/`, payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar a dívida.'),
      );
    }
  },

  async archive(id) {
    try {
      const { data } = await apiClient.post(`/liabilities/${id}/archive/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível arquivar a dívida.'),
      );
    }
  },

  async restore(id) {
    try {
      const { data } = await apiClient.post(`/liabilities/${id}/restore/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível reactivar a dívida.'),
      );
    }
  },

  async getRepaymentPlan(method = 'avalanche') {
    try {
      const { data } = await apiClient.get(
        `/liabilities/repayment-plan/?method=${method}`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível calcular o plano.'),
      );
    }
  },

  async evaluateNew(payload) {
    try {
      const { data } = await apiClient.post('/liabilities/evaluate-new/', payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível avaliar a dívida.'),
      );
    }
  },

  async simulateExtra(id, payload) {
    try {
      const { data } = await apiClient.post(
        `/liabilities/${id}/simulate-extra/`,
        payload,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível simular a amortização.'),
      );
    }
  },

  async hasBadDebts() {
    try {
      const { data } = await apiClient.get('/liabilities/has-bad-debts/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível verificar as dívidas.'),
      );
    }
  },

  async getActivePlan() {
    try {
      const { data } = await apiClient.get('/liabilities/active-plan/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o plano activo.'),
      );
    }
  },

  async savePlan(payload) {
    try {
      const { data } = await apiClient.post('/liabilities/save-plan/', payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível guardar o plano.'),
      );
    }
  },
};
